import styled from 'styled-components';
import { media } from '@quiqupltd/qu-react-sdk/lib/styles/mixins/media';

export const Container = styled.div`
  flex: 1;
  padding: 0 16px 24px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.06);
  ${media.up('phone')`
    padding: 0 48px 36px;
    height: 124px;
  `};
`;



// WEBPACK FOOTER //
// ./src/app/order-card/pending/body/styles.js